import { loadsTabModes } from './loadsTabModes';

import {
  ADD_LOADS_COMBINATION,
  UPDATE_LOADS_COMBINATION,
  SELECT_ALL_LOADS_COMBINATION,
  SET_LOADS_TAB_MODE,
  REMOVE_ALL_SELECTED_LOADS_COMBINATION,
  SET_ACTIVE_COMBINATION,
  TOGGLE_SELECTION_OF_COMBINATION,
  CHANGE_COMBINATION_LOAD_TYPE,
  UPDATE_EXTRA_COMBINATION_FIELD,
  RESET_EXTRA_COMBINATION_FIELD,
  UPDATE_CALCULATE_DESIGN_LOAD_DATA,
  SET_BRACKET_ATTACHMENT_LOAD,
  SET_BRACKET_ATTACHMENT_LOAD_L,
  SET_SAFETY_BARRIERS_EXTERNAL_DIRECTION,
  TOGGLE_SAFETY_BARRIERS_INTERNAL_DIRECTION,
  SET_SAFETY_BARRIERS_INTERNAL_DIRECTION_TYPE,
  SET_SAFETY_BARRIERS_LOAD_BETWEEN_POSTS,
  SET_SAFETY_BARRIERS_LOAD_PER_LENGTH,
  SET_BRACKET_ATTACHMENT_LOAD_LG,
  SET_BRACKET_ATTACHMENT_LOAD_F,
  SET_BRACKET_ATTACHMENT_LOAD_NR,
  SET_BRACKET_ATTACHMENT_WEIGHT_P,
  SET_REBAR_REINFORCEMENT_NZ,
  SET_REBAR_REINFORCEMENT_TYPE,
  SET_REBAR_REINFORCEMENT_WORKING_LIFE,
  RESET_LOADS_STATE,
  SET_LOADS_STATE,
  SET_IMPORT_COMBINATIONS_STATE,
  SET_IMPORT_COMBINATIONS_DATA,
  SET_IMPORT_COMBINATIONS_HEADER,
  SET_IMPORT_COMBINATIONS_UNIT,
  RESET_IMPORT_DATA,
  APPLY_IMPORTED_COMBINATIONS,
  SET_CLADDING_DEAD_LOAD,
  SET_CLADDING_WIND_LOAD,
    SET_CLADDING_BUILDING_DESCRIPTION,
    SET_WOOD_CONNECTION_PATTERN,
    SET_WOOD_CONNECTION_N_VALUE,
    SET_WOOD_CONNECTION_LOAD_TYPE,
    SET_WOOD_CONNECTION_LOAD_VALUE,
    SET_WOOD_CONNECTION_KMOD_FACTOR
} from './actions';
import { APP_TYPES, BRAND, defaultUnits } from '@config';
import { mergeDeep } from '@services/helper.service';
import { Combination } from '@views/Loads/GeneralLoading/DesignLoading/misc/combination.class';
import { brandList, countryList } from './../../../app.values';
import { loadTypes } from './../../../views/Loads/GeneralLoading/DesignLoading/misc/combination.class';
// import defaultExtraField from '@views/Loads/GeneralLoading/DesignLoading/misc/defaultExtraField';
// import { APP_TEXTS } from '../../../texts/texts';


export const EXTERNAL_TYPES = {
  DOMESTIC_AND_RESIDENTIAL: 'domestic_and_residential',
  OFFICE_AREAS: 'office_areas',
  PUBLIC_BUILDINGS: 'public_buildings',
  SHOPPING_AREAS: 'shopping_areas',
  INDUSTRIAL_AREAS_SUSCEPTIBLE: 'industrial_areas_susceptible',
  INDUSTRIAL_AREAS: 'industrial_areas',
  SPECTATORS_FACILITIES: 'spectators_facilities',
  EXTERNAL_DIRECTION_CUSTOM: 'external_direction_custom'
};

export const INTERNAL_TYPES = {
  CUSTOM_PER_LENGTH: 'custom_per_length',
  CUSTOM_BETWEEN_POSTS: 'custom_between_posts'
};

export const NAILPATTERN_TYPES = {
  FULL: 'full',
  PARTIAL: 'partial'
};

export const initState = {
  [APP_TYPES.GENERAL_CALCULATION]: {
    loadsTabMode: loadsTabModes.DESIGN,

    designLoadingData: [
      // {
      //   Nz: 0,
      //   Vx: 0,
      //   Vy: 0,
      //   Mx: 0,
      //   My: 0,
      //   Mz: 0,
      //   loadType: 'standard',
      //   isSelected: true,
      //   isRemoved: false,
      //   isActive: true,
      //   influence: null,
      //   name: `${APP_TEXTS.LOADS_COMBINATION_NAME.Content.replace("{0}", "1")}`, //'Combination 1',
      //   extraField: mergeDeep({}, defaultExtraField[loadTypes.STANDARD])
      // }
    ],
    activeCombinationIndex: 0,
    combinationCounter: 0,

    calculateDesignLoadData: {
      deadLoad: {
        partialSafetyFactor: BRAND === brandList.Sea ? 2 : 1.35,
        nz: 0,
        vx: 0,
        vy: 0,
        mx: 0,
        my: 0,
        mz: 0
      },
      liveLoad: {
        partialSafetyFactor: 1.5,
        nz: 0,
        vx: 0,
        vy: 0,
        mx: 0,
        my: 0,
        mz: 0
      },
      temporaryLoad: {
        partialSafetyFactor: 1.75,
        nz: 0,
        vx: 0,
        vy: 0,
        mx: 0,
        my: 0,
        mz: 0
      }
    },

    importState: {
      isImporting: false,
      headers: ['Nz', 'Vx', 'Vy', 'Mz', 'Mx', 'My'],
      data: [],
      units: {
        load: defaultUnits.LOAD,
        moment: defaultUnits.MOMENT
      }
    }
  },

  [APP_TYPES.BRACKET_ATTACHMENT]: {
    l: 500,
    lg: 200,
    loadF: 0.00,
    loadNr: 0.00,
    weightP: 0
  },

  [APP_TYPES.SAFETY_BARRIER]: {
    externalDirection: {
      type: 'domestic_and_residential',
      value: 0.6
    },
    hasInternalDirection: true,
    internalDirection: {
      type: 'custom_between_posts',
      loadBetweenPosts: 0.27,
      loadPerLength: 0.4
    },
     deadLoad: {
      g: 0 
    },
    windLoad: {
      windZone: 0,
      vb: 0,
      groundCategory: ''
    },
    buildingDescription: {
      width: 0, 
      length: 0, 
      height: 0, 
      barrierHeight: 0,
      isEdge: false 
    },
  },

  [APP_TYPES.REBAR_REINFORCEMENT]: {
    type: '/lm',
    nz: 0,
    wl: 50
  },

  [APP_TYPES.WOOD_CONNECTION]: {
    nailPattern : NAILPATTERN_TYPES.FULL,
    nValue: 9,
    loadType: loadTypes.STANDARD,
    upliftLoadFaxd: 0,
    kmodFactor: 1.1
  }
};

const loads = (state = mergeDeep({}, initState), action) => {
  switch (action.type) {
    case SET_LOADS_TAB_MODE: {
      state[APP_TYPES.GENERAL_CALCULATION].loadsTabMode = action.mode;

      return mergeDeep({}, state);
    }
    case ADD_LOADS_COMBINATION: {
      const lastIndex = state[APP_TYPES.GENERAL_CALCULATION].combinationCounter;
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          designLoadingData: [
            ...state[APP_TYPES.GENERAL_CALCULATION].designLoadingData,
            new Combination(
              lastIndex, null, 0, 0, 0, 0, 0, 0,
              Number(action.country) === countryList["New Zealand"] ? loadTypes.SEISMIC : loadTypes.STANDARD)
          ],
          combinationCounter: ++state[APP_TYPES.GENERAL_CALCULATION].combinationCounter
        }
      });
    }
    case UPDATE_LOADS_COMBINATION: {
      // VladP: mutating the state will prevent rerendering, however map returns a new array
      if (action.options) {
        let func = (item, index) => {
          if (index !== action.index)
            return item;
          else
            return mergeDeep(new Combination(), item, action.options);
        };

        if (state[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
          return mergeDeep({}, state, {
            [APP_TYPES.GENERAL_CALCULATION]: {
              importState: {
                data: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(func)
          }}});
        } else {
          return mergeDeep({}, state, {
            [APP_TYPES.GENERAL_CALCULATION]: {
              designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map(func)
          }});
        }
      } else {
        return state;
      }
    }
    case SELECT_ALL_LOADS_COMBINATION: {
      let func = (item) => {
        item.isSelected = action.value;
        return item;
      };
      if (state[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            importState: {
              data: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(func)
        }}});
      } else {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map(func)
        }});
      }
    }
    case REMOVE_ALL_SELECTED_LOADS_COMBINATION: {
      const data = state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.filter(item => (
        !item.isSelected
      ));

      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          designLoadingData: data
        }
      });
    }
    case SET_ACTIVE_COMBINATION: {
      let func = (item, index) => {
        item.isActive = index === action.index;
        return item;
      };
      if (state[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            activeCombinationIndex: action.index,
            importState: {
              data: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(func)
        }}});
      } else {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            activeCombinationIndex: action.index,
            designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map(func)
        }});
      }
    }
    case TOGGLE_SELECTION_OF_COMBINATION: {
      let func = (item, index) => {
        item.isSelected = index === action.index ? !item.isSelected : item.isSelected;
        return item;
      };

      if (state[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            importState: {
              data: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(func)
        }}});
      } else {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map(func)
        }});
      }
    }
    case CHANGE_COMBINATION_LOAD_TYPE: {
      let func = (item, index) => {
        item.loadType = index === action.index ? action.value : item.loadType;
        return item;
      };
      if (state[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            importState: {
              data: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(func)
        }}});
      } else {
        return mergeDeep({}, state, {
          [APP_TYPES.GENERAL_CALCULATION]: {
            designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map(func)
        }});
      }
    }
    case UPDATE_EXTRA_COMBINATION_FIELD: {
      // state[APP_TYPES.GENERAL_CALCULATION].designLoadingData[action.index].extraField = {
      //   ...state[APP_TYPES.GENERAL_CALCULATION].designLoadingData[action.index].extraField,
      //   ...action.options
      // };
      // return mergeDeep({}, state);
      const newList = state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map((item, index) => {
        return index === action.index ?
          mergeDeep(
            {},
            item,
          { extraField: mergeDeep({}, state[APP_TYPES.GENERAL_CALCULATION].designLoadingData[action.index].extraField, action.options)}
          ) : item;
      });
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          designLoadingData: newList
        }
      });
    }
    case RESET_EXTRA_COMBINATION_FIELD: {
      const newList = state[APP_TYPES.GENERAL_CALCULATION].designLoadingData.map((item, index) => {
        return index === action.index ? mergeDeep({}, item, { extraField: action.options }) : item;
      });
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          designLoadingData: newList
        }
      });
    }
    case UPDATE_CALCULATE_DESIGN_LOAD_DATA: {
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          calculateDesignLoadData: {
            ...action.options
          }
        }
      });
    }
    case SET_IMPORT_COMBINATIONS_STATE: {
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          importState: {
            isImporting: action.value
          }
        }
      });
    }
    case SET_IMPORT_COMBINATIONS_DATA: {
      let newState = {
        data: action.data
      };
      if (action.headers)
        newState.headers = action.headers;
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          importState: newState
        }
      });
    }
    case SET_IMPORT_COMBINATIONS_HEADER: {
      let newHeaders = Array.from(state[APP_TYPES.GENERAL_CALCULATION].importState.headers);
      let loadName = action.value.replace('-', '');
      let valueIdx = newHeaders.findIndex(elem => elem.includes(loadName));
      if (valueIdx === -1 || valueIdx === action.idx)
        newHeaders[action.idx] = action.value;
      else {
        // switch loads
        let temp = newHeaders[action.idx];
        newHeaders[action.idx] = action.value;
        newHeaders[valueIdx] = temp;
      }
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          importState: {
            headers: newHeaders
          }
        }
      });
    }
    case SET_IMPORT_COMBINATIONS_UNIT: {
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          importState: {
            units: mergeDeep({}, state[APP_TYPES.GENERAL_CALCULATION].importState.units, action.value)
          }
        }
      });
    }
    case RESET_IMPORT_DATA: {
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          importState: mergeDeep({}, initState[APP_TYPES.GENERAL_CALCULATION].importState)
        }
      });
    }
    case APPLY_IMPORTED_COMBINATIONS: {
      let headers = state[APP_TYPES.GENERAL_CALCULATION].importState.headers;
      return mergeDeep({}, state, {
        [APP_TYPES.GENERAL_CALCULATION]: {
          designLoadingData: state[APP_TYPES.GENERAL_CALCULATION].importState.data.map(c => {
            return c.switchHeadersOrder(headers);
          }),
          combinationCounter: state[APP_TYPES.GENERAL_CALCULATION].importState.data.length
        }
      });
    }

    case SET_BRACKET_ATTACHMENT_LOAD: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          [action.key]: action.value
        }
      });
    }
    case SET_BRACKET_ATTACHMENT_LOAD_L: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          l: action.value
        }
      });
    }
    case SET_BRACKET_ATTACHMENT_LOAD_LG: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          lg: action.value
        }
      });
    }
    case SET_BRACKET_ATTACHMENT_LOAD_F: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          loadF: action.value
        }
      });
    }
    case SET_BRACKET_ATTACHMENT_LOAD_NR: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          loadNr: action.value
        }
      });
    }
    case SET_BRACKET_ATTACHMENT_WEIGHT_P: {
      return mergeDeep({}, state, {
        [APP_TYPES.BRACKET_ATTACHMENT]: {
          weightP: action.value
        }
      });
    }

    case SET_SAFETY_BARRIERS_EXTERNAL_DIRECTION: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          externalDirection: {
            type: action.typeValue,
            value: action.value
          }
        }
      });
    }
    case TOGGLE_SAFETY_BARRIERS_INTERNAL_DIRECTION: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          hasInternalDirection: action.value
        }
      });
    }
    case SET_SAFETY_BARRIERS_INTERNAL_DIRECTION_TYPE: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          internalDirection: {
            type: action.value
          }
        }
      });
    }
    case SET_SAFETY_BARRIERS_LOAD_BETWEEN_POSTS: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          internalDirection: {
            loadBetweenPosts: action.value
          }
        }
      });
    }
    case SET_SAFETY_BARRIERS_LOAD_PER_LENGTH: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          internalDirection: {
            loadPerLength: action.value
          }
        }
      });
    }

    case SET_REBAR_REINFORCEMENT_TYPE: {
      return mergeDeep({}, state, {
        [APP_TYPES.REBAR_REINFORCEMENT]: {
          type: action.value,
        }
      });
    }
    case SET_REBAR_REINFORCEMENT_NZ: {
      return mergeDeep({}, state, {
        [APP_TYPES.REBAR_REINFORCEMENT]: {
          nz: action.value
        }
      });
    }
    case SET_REBAR_REINFORCEMENT_WORKING_LIFE: {
      return mergeDeep({}, state, {
        [APP_TYPES.REBAR_REINFORCEMENT]: {
          wl: action.value
        }
      });
    }
  case SET_CLADDING_DEAD_LOAD: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          deadLoad: {
            g: action.value
          }
        }
      });
    }
    case SET_CLADDING_WIND_LOAD: {
   return mergeDeep({}, state, {
    [APP_TYPES.SAFETY_BARRIER]: {
      windLoad: {
        ...state[APP_TYPES.SAFETY_BARRIER].windLoad,
        ...action.options
      }
    }
      });
    }
    case SET_CLADDING_BUILDING_DESCRIPTION: {
      return mergeDeep({}, state, {
        [APP_TYPES.SAFETY_BARRIER]: {
          buildingDescription: {
            ...state[APP_TYPES.SAFETY_BARRIER].buildingDescription,
            ...action.dimensions
          }
        }
      });
    }
    case RESET_LOADS_STATE: {
      return mergeDeep({}, state, {
        [action.appType]: mergeDeep({}, initState[action.appType])
      });
    }
    case SET_LOADS_STATE: {
      return action.state;
    }
    case SET_WOOD_CONNECTION_PATTERN: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          nailPattern: action.value
        }
      });
    }

    case SET_WOOD_CONNECTION_N_VALUE: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          nValue: action.value
        }
      });
    }

    case SET_WOOD_CONNECTION_LOAD_TYPE: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          loadType: action.value
        }
      });
    }

    case SET_WOOD_CONNECTION_LOAD_VALUE: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          upliftLoadFaxd: action.value
        }
      });
    }
    case SET_WOOD_CONNECTION_KMOD_FACTOR: {
      return mergeDeep({}, state, {
        [APP_TYPES.WOOD_CONNECTION]: {
          kmodFactor: action.value
        }
      });
    }

    default: {
      return state;
    }
  }
};

export default loads;



// WEBPACK FOOTER //
// ./src/reducers/selectors/loads/index.js